import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxExpenseRegister = cashBoxRegister("CashBoxExpenseRegister")

export default CashBoxExpenseRegister
